<template>
	<u-animate-container>
		<div class="privacy_policy">
			<div class="container-fluid pb-5 container-top">
				<div class="container p-0">
					<b-row>
						<b-col cols="12" class="text-center pt-5 mt-5 p-0">
				    		<h1 class="section-title">{{configs['privacy_policy_title']}}</h1>
							<b-col md="8" offset-md="2">
								<p v-html="configs['privacy_policy_welcome_txt']"></p>
							</b-col>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="container content position-relative space-to-footer">
				<b-row v-for="(item, idx) in configs.privacy_policy_articles" :key="idx" :class="(idx !== 0) ? 'mt-4' : ''">
					<b-col cols="12">
						<div>
							<h3 class="section-title line-up-dark d-inline-block align-top">
								{{item.title}}
							</h3>
							<p class="mt-2 text-justify" v-html="item.text"></p>
						</div>
					</b-col>
				</b-row>
			</div>
			<Footer></Footer>
		</div>
	</u-animate-container>
</template>
<script>

export default {
  name: 'privacy_policy'
}
</script>
<style scoped>
.container-top {
	background-image: url('../assets/images/Background_Privacy_Policy.jpg');
}
.privacy_policy >>> a.icon-link { /* deep selectos, https://medium.com/@brockreece/scoped-styles-with-v-html-c0f6d2dc5d8e*/
  color: inherit;
}
.privacy_policy >>> a.icon-link:hover {
  text-decoration: underline;
}
</style>